export default __webpack_public_path__ + "static/media/earnings-mobile-bg.f0c8a041.webp";